import React from 'react';

const DrawerContext = React.createContext({});
const DrawerProvider = ({ children, close }) => {
    return React.createElement(DrawerContext.Provider, { value: { close: close } }, children);
};

export { DrawerContext, DrawerProvider };
//# sourceMappingURL=DrawerProvider.js.map
